import { ListItem, ListItemButton, ListItemText } from "@mui/material";

import { NavigationItem } from "./types";

export interface JumpToSideBarItemProps {
  item: NavigationItem;
  onItemClick: (itemId: string) => void;
}

export const JumpToSideBarItem = ({ item, onItemClick }: JumpToSideBarItemProps) => {
  const handleClick = () => {
    onItemClick(item.id);
  };

  return (
    <ListItem
      disablePadding
      sx={{ display: "block", paddingY: 0, marginY: 1 }}
      data-step-key={item.id}
      data-test={`nav-item-${item.id}`}
    >
      <ListItemButton
        onClick={handleClick}
        sx={{
          py: 1,
          justifyContent: "initial",
          px: 2.5,
          backgroundColor: (theme) =>
            item.isActive ? theme.palette.surface.brand.quiet : theme.palette.background.paper,
          border: (theme) => `1px solid ${theme.palette.border.brand.quiet}`,
          borderRadius: 1,
          display: "flex",
          alignItems: "center",
          cursor: item.isActive ? "default" : "pointer",
        }}
      >
        <ListItemText
          primary={item.label}
          primaryTypographyProps={{
            variant: "subtitle2",
            sx: {
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
          }}
          sx={{
            opacity: 1,
            color: (theme) => theme.palette.text.brand.intense,
            margin: 0,
          }}
        />
      </ListItemButton>
    </ListItem>
  );
};
